import React from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
// eslint-disable-next-line import/no-unresolved
import { useDevice } from '../../../hooks/useResponsive';

export default function Feature() {
  const { isMobile } = useDevice();

  // const [scrollValue, setScrollValue] = useState();

  // useEffect(() => {
  //   const handleScroll = () => {
  //     setScrollValue(window.scrollY);
  //   };

  //   window.addEventListener('scroll', handleScroll);

  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  const features = [
    {
      image: '/assets/images/Feature/finance.png',
      heading: 'Finance',
      description: 'Upto <span style="font-size: 1rem;">90%</span>',
    },
    {
      image: '/assets/images/Feature/warrenty.png',
      heading: 'Warranty',
      description: 'Upto <span style="font-size: 1rem;">12</span> months',
    },
    {
      image: '/assets/images/Feature/paperWork.png',
      heading: 'Paper works',
      description: 'within <span style="font-size: 1rem;">30</span> min',
    },
    {
      image: '/assets/images/Feature/india.png',
      heading: 'Pan India',
      description: 'Road Assistance',
    },
    {
      image: '/assets/images/Feature/quality.png',
      heading: '130+',
      description: 'Quality Checks',
    },
    {
      image: '/assets/images/Feature/exchange.png',
      heading: 'Exchange',
      description: 'Available',
    },
  ];
  const featuresWeb = [
    {
      image: '/assets/images/Feature/finance.png',
      heading: 'Finance',
      description: 'Upto <span style="font-size: 1.5rem;">90%</span>',
    },
    {
      image: '/assets/images/Feature/warrenty.png',
      heading: 'Warranty',
      description: 'Upto <span style="font-size: 1.5rem;">12</span> months',
    },
    {
      image: '/assets/images/Feature/paperWork.png',
      heading: 'Paper works',
      description: 'within <span style="font-size: 1.5rem;">30</span> min',
    },
    {
      image: '/assets/images/Feature/india.png',
      heading: 'Pan India',
      description: 'Road Assistance',
    },
    {
      image: '/assets/images/Feature/quality.png',
      heading: '130+',
      description: 'Quality Checks',
    },
    {
      image: '/assets/images/Feature/exchange.png',
      heading: 'Exchange',
      description: 'Available',
    },
  ];
  const currentFeatures = isMobile ? features : featuresWeb;

  return (
    <>
      <Stack
        className=""
        sx={{
          paddingTop: { xs: '0', sm: '140px' },
          paddingBottom: { xs: '0', sm: '70px' },
          px: isMobile ? 4 : '110px',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: !isMobile && 10,
          mb: isMobile ? '1rem' : 0,
        }}
      >
        <Stack pt={3} pb={8} width={{ xs: '100%', md: '50%' }} alignItems="center" justifyContent="center">
          <Stack alignItems="flex-start">
            <Typography color="#FFFFFF99" textAlign="center" fontWeight="500" fontSize={isMobile ? 16 : 20}>
              Why You Should Choose
            </Typography>
            <Typography
              className="oxanium-bold-text"
              textAlign="center"
              fontSize={isMobile ? '19px' : '32px'}
              fontWeight="900"
              color="#FFA800"
            >
              FOCUS MOTORS?
            </Typography>
          </Stack>
        </Stack>
        <Grid container direction="row">
          {/* <Box display={'flex'} justifyContent={'center'} width={'100%'}>
              <img src={`/assets/images/Home/focusFav.png`} alt="" />
            </Box> */}

          {currentFeatures?.map((feature, key) => {
            const alignmentMap = ['flex-start', 'center', 'flex-end'];
            const alignValue = alignmentMap[key % 3]; // repeat every 3 items
            const isLastRow = key >= 3;

            return (
              <Grid
                item
                xs={4}
                md={4}
                lg={4}
                mb={3}
                key={key}
                display="flex"
                flexDirection="column"
                alignItems={alignValue}
                justifyContent="center"
              >
                <Box display="flex" mb={1}>
                  <img src={feature?.image} alt="" height={isMobile ? 50 : 81} />
                </Box>
                <Typography
                  color="#FFFFFFDE"
                  fontWeight="500"
                  fontSize={isLastRow ? (isMobile ? 16 : 25) : isMobile ? 12 : 19}
                >
                  {feature?.heading}
                </Typography>
                <Typography
                  color="#FFFFFFDE"
                  fontWeight="500"
                  fontSize={isMobile ? 12 : 18}
                  dangerouslySetInnerHTML={{ __html: feature?.description }}
                />
              </Grid>
            );
          })}

          {/* <Box display={'flex'} justifyContent={'center'} width={'100%'} my={6}> */}
          {/* <video height={'100px'} autoPlay muted controls={false} className="upgrade-video">
                <source src="/assets/images/Feature/upgrade.mp4" type="video/mp4" />
                <track kind="captions" src="your-captions-file.vtt" srcLang="en" label="English" />
              </video> */}
          {/* <img
                src={isMobile ? `/assets/images/Feature/upgrade.png` : `/assets/images/Feature/upgradeWeb.png`}
                alt=""
              /> */}
          {/* </Box> */}
        </Grid>
      </Stack>
    </>
  );
}
